import { render, staticRenderFns } from "./CustomTransition.vue?vue&type=template&id=3c4d0256&"
import script from "./CustomTransition.vue?vue&type=script&lang=js&"
export * from "./CustomTransition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports